const CHANNEL_NAME = "auth";

const authChannel =
  typeof BroadcastChannel !== "undefined"
    ? new BroadcastChannel(CHANNEL_NAME)
    : null;

// Tells every other open tab that the session just ended.
// BroadcastChannel never delivers a message back to the tab that sent it,
// so this is safe to call from the same place that performs the local sign-out.
export const broadcastLogout = () => {
  authChannel?.postMessage({ type: "logout" });
};

// Runs `callback` whenever another tab reports a logout. Returns an unsubscribe function.
export const subscribeToLogout = (callback) => {
  if (!authChannel) return () => {};

  const handleMessage = (event) => {
    if (event.data?.type === "logout") {
      callback();
    }
  };

  authChannel.addEventListener("message", handleMessage);
  return () => authChannel.removeEventListener("message", handleMessage);
};
